import React, {Component, Fragment} from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Select from 'react-select'
import Spinner from "../spinner/spinner.component";
import ReservationStep3 from './reservationstep3.component';
import { SELECTED_QUANTITIES_EXCEDED, SELECTED_QUANTITIES_SMALLER_THAN_EXPECTED } from '../../config/messages';
import { storeSelectedTickets, removeSelectedTickets } from '../../actions/movietheaters.actions';

class ReservationStep2 extends Component {

    constructor(props){
        super(props);
        this.state = {
            totalTicketsSeats: this.props.selectedSeats.length,
            totalTicketsCouch: this.props.selectedCouch.length / 2,
            fees: [],
            errorMessage: "",
            nextStep: false
        }
    }

    componentWillMount() {
        this.props.fees.map(fee => {
            this.state.fees.push({...fee, quantity: 0, totalPrice: 0.00});
        }); 

        this.props.storeSelectedTickets(this.state.fees);
    }

    selectedSeatsCode = () => {
        const seatsLength = this.props.selectedSeats.length;
        const couchLength = this.props.selectedCouch.length;
        const totalLenght = seatsLength + couchLength;
        let string = '';
        this.props.selectedSeats.map((seat,i) => {     
            const newI = i+1;
            if(newI < totalLenght) {
                string += seat.code + ', ';
            } else {
                string += seat.code
            }
        });
        this.props.selectedCouch.map((couch, i) => {
            const newI = i+1;
            if(newI < couchLength) {
                string += couch.code + ', ';
            } else {
                string += couch.code
            }
        });
        return string;
    }

    seatsCount = () => {
        const length = this.props.selectedSeats.length + this.props.selectedCouch.length / 2;
        let string = '';
        if (length === 1){
            string = length + ' loc';
        }
        else{
            string = length + ' locuri';
        }

        return string;
    }

    handleChange = (selectedOption) => {
        const index = this.state.fees.findIndex(item => item.id_fee === selectedOption.value.id);
        if (selectedOption.value.value === 'reset'){    
            this.state.fees[index].quantity = 0;
            this.state.fees[index].totalPrice = 0;
            this.forceUpdate();
        }
        else {
            this.state.fees[index].quantity = selectedOption.label;
            const totalPrice = selectedOption.value.price * this.state.fees[index].quantity
            this.state.fees[index].totalPrice = Number(Math.round(totalPrice +'e2')+'e-2').toFixed(2);
            this.forceUpdate();
        }

        this.props.storeSelectedTickets(this.state.fees);
    }

    fees = () => {
        const customStyles = {
            option: (provided, state) => ({
                ...provided,
                borderBottom: '1px dotted #cfcfcf',
                color: state.isSelected ? '#22BFD1' : '#6C7B82',
                padding: 5,
                backgroundColor: state.isSelected ? '#cfcfcf' : '#ffffff',
                
            })
        }
        return this.state.fees.map((fee, i) => { 
            const options = [{value: {value:'reset', id: fee.id_fee}, label: '0'}];
            const value = {id: fee.id_fee, price: Number(Math.round(fee.price +'e2')+'e-2').toFixed(2)}
            // check if iterated ticket is couch related
            if (fee.one4two == "1"){ 
                for (let j=1; j <= this.state.totalTicketsCouch; j++){
                    options.push({value: value, label: j });
                }
            } else {
                for (let j=1; j <= this.state.totalTicketsSeats; j++){
                    options.push({value: value, label: j });
                }        
            }
            
       
            return <Fragment key={i}>
                <div className="col-md-5 col-sm-4">
                    <p className="fee-name">{fee.name}</p>
                </div>
                <div className="col-md-2 col-sm-4">
                    <Select options={options} styles={customStyles} onChange={this.handleChange} placeholder={0} />
                </div>
                <div className="col-md-3 col-sm-2">
                    <p className=" blue-text">{ Number(Math.round(fee.price +'e2')+'e-2').toFixed(2)} lei/bilet</p>
                </div>
                <div className="col-md-2 col-sm-2">
                    <p className="show-price blue-text">{fee.totalPrice} lei</p>
                </div>
            </Fragment>
        });
    }

    totalPrice = () => {
        let totalPrice = 0;
        this.state.fees.map(fee => {
            totalPrice = totalPrice + parseFloat(fee.totalPrice);
        })
        return Number(Math.round(totalPrice +'e2')+'e-2').toFixed(2);
    }

    oneForTwoErrorMessage(){
        let seats = "";
        let couch = "";

        this.state.totalTicketsSeats !== 1 ? seats = "scaune" : seats = "scaun";
        this.state.totalTicketsCouch !== 1 ? couch = "canapele" : couch = "canapea";

        return `Trebuie să selectați biletele pentru ${this.state.totalTicketsSeats} ${seats} și ${this.state.totalTicketsCouch} ${couch}`;
    }

    goToNextStep = () => {
        let totalQuantities = 0;
        let oneForTwo = 0;
        this.state.fees.map(fee => {     
            if(fee.quantity !== 0){
                if (fee.name.includes("One4Two")){
                    oneForTwo = fee.quantity
                }
                totalQuantities = totalQuantities + fee.quantity
            }
        });
        let totalTickets = this.state.totalTicketsSeats + this.state.totalTicketsCouch;
        if (totalQuantities > totalTickets){
            this.setState({errorMessage: SELECTED_QUANTITIES_EXCEDED});
        }
        else if(totalQuantities < totalTickets){
            this.setState({errorMessage: SELECTED_QUANTITIES_SMALLER_THAN_EXPECTED});    
        }
        else if(oneForTwo !== this.state.totalTicketsCouch){
            this.setState({errorMessage: this.oneForTwoErrorMessage()});
        } 
        else {
            this.setState({errorMessage: ''})
            this.setState({
                nextStep: !this.state.nextStep
            })
        }
    }
    changeBackground() {
        let x = document.getElementsByClassName("modal-backdrop");
        if (x.length !== 0) {
            x[0].classList.add("background-gray");
        }   
    }

    render() {
        return (
            <Fragment>
                {this.changeBackground()}
                {this.props.loading !== 0 ? <Spinner /> : ''}
                { !this.state.nextStep ? 
                <div className="step-2">
                    <div className="modal-right-header">
                        <span className="title-movie">{this.props.movie.film_title}</span><br/>
                        <span className="modal-translated">{this.props.movie.film_translated_title}</span>
                        <hr />
                        <p>TIPUL BILETELOR</p>
                        <div className="terms">
                            <p>Deținătorii de bilete cu tarif redus sunt obligați să facă dovada statutului social in baza căruia au achiziționat respectivele bilete, înainte de intrarea în sala de cinematograf. În situația de mai sus, în cazul persoanelor care fac dovada cu carnet elev/carnet student/talon pensie, după caz, Cinema One iși rezervă dreptul de a nu permite accesul acestora în sala de cinematograf, considerând că au acționat cu rea-credință și au încercat să obțină un folos material în detrimentul intereselor Cinema One.</p>
                            <p>Acest demers vine ca o masură suplimentară de securitate, pentru a proteja siguranța achiziționării biletelor în sistem online.</p>
                            <p>Recomandăm verificarea încadrării corecte a categoriilor de bilete selectate. În cazul în care alegeți o altă categorie, va fi necesară stornarea biletelor la casieria cinematografului și achiziționarea tipurilor de bilete corespunzătoare deținătorului. Trebuie avut în vedere faptul că există riscul pierderii locurilor alese.</p>
                        </div>
                        <div className="actions">
                            <p>AI SELECTAT: <span className="blue-text">{this.seatsCount()}</span></p>
                        </div>
                        <div className="row tickets-selection">
                            <div className="col-lg-9">
                                <div className="d-none d-sm-block">
                                    <div className="row">
                                        <div className="col-sm-5">
                                        </div>
                                        <div className="col-sm-2">
                                            <p>Cantitatea</p>
                                        </div>
                                        <div className="col-sm-3">
                                        </div>
                                        <div className="col-sm-2">
                                            <p>Preţul</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="row item-ticket">
                                  {this.fees()}
                                </div>
                                <hr/>
                            </div>
                            <div className="col-lg-3">
                                <p className="text-capitalize">{this.props.scheduleTime.day}, {this.props.scheduleTime.selectedDate}</p>
                                <div className="item-hours clearfix">
                                    <span className="radius-item">{this.props.scheduleTime.projectionFormat}</span>
                                    <span className="hour-item">{this.props.scheduleTime.selectedHour}</span>
                                </div>
                                <p>Prețul total</p>
                                <p className="blue-text">{this.totalPrice()} lei</p>
                                <p>Locuri selectate în sală</p>
                                <p className="blue-text fs12">{this.selectedSeatsCode()} </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-12"> 
                        <span>{this.state.errorMessage}</span>
                    </div>
                    <div className="row">
                        {<button className="next-step" onClick={this.goToNextStep}>Cumpără</button>}
                    </div>
                </div> : <ReservationStep3 />}
            </Fragment>
        );
    }
}

const mapStateToProps = state => ({
    loading: state.loading.pendingRequests,
    movie: state.movies.movieDetails,
    selectedSeats: state.movieTheaters.selectedSeats,
    selectedCouch: state.movieTheaters.selectedCouch,
    selectedHour: state.filters.movieDetailsFilters,
    selectedDate: state.filters.reservetionSelectedDate,
    fees: state.movieTheaters.hallConfiguration.fees,
    storedTickets: state.movieTheaters.selectedTickets
});
export default withRouter(connect(mapStateToProps, {storeSelectedTickets, removeSelectedTickets})(ReservationStep2));







// WEBPACK FOOTER //
// ./src/SHARED/components/modalreservation/reservationstep2.component.js